import { FileUpload } from '@/components/shared/FileUpload';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import usePdfFile from '@/data/hook/shared/usePdfFile';
import { formatFileSizeLabel } from '@/utils/file';

type PdfSavedFileMetaProps = {
  url: string;
};

export default function PdfSavedFileMeta({ url }: PdfSavedFileMetaProps) {
  const { size } = usePdfFile(url);

  return (
    <ConditionalRenderer condition={size}>
      <FileUpload.Item.Meta>
        {formatFileSizeLabel(size ?? 0)}
      </FileUpload.Item.Meta>
    </ConditionalRenderer>
  );
}
